import styled from 'styled-components';

import Column from './Column';
import Row from './Row';

export default styled(Row)`
  grid-template-columns: 58px auto;
  padding: 0;

  & > ${Column} {
    padding: ${props => props.theme.spacing(2)}px;
  }
`;
